import styled from 'styled-components'

export const AttemptText = styled.span`
  color: #394dff;
`
